/**
 * Format date in readable format: "November 12th, 2025 CST"
 * Parses in local timezone to avoid timezone conversion issues
 */
export const formatReadableDate = (dateStr, timezone = 'CST') => {
  // Parse in local timezone to prevent off-by-one errors
  const [year, month, day] = dateStr.split('-');
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  
  const dayNum = date.getDate();
  const monthName = date.toLocaleDateString('en-US', { month: 'long' });
  const yearNum = date.getFullYear();
  
  // Add ordinal suffix (1st, 2nd, 3rd, 4th, etc.)
  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };
  
  return `${monthName} ${dayNum}${suffix(dayNum)}, ${yearNum}`;
};

/**
 * Format date in short format: "Nov 12, 2025"
 */
export const formatShortDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
};
